<template>
    <base-modal
      :customShowDialog="customShowDialog"
      :title="$t('modal.generatedKeywords.title')"
      dialogMaxWidth="45vw"
      :confirmButton="$t('modal.generatedKeywords.confirmBtn')"
      :confirmEnabled="chosenItems.length > 0"
      @close="handleCloseClick"
      @confirmed="handleConfirmedClick"
    >
      <div slot="body">
          <div class="mb-2 text-xs-left caption" style="display: flex; justify-content: space-between">
            <span>{{ $t('modal.generatedKeywords.subtitle') }}<span class="modal-text">"{{seedTerm}}"</span></span>
            <i18n path="modal.generatedKeywords.translationSource" tag="span" id="suggest-terms-meta-text">
              <template v-slot:methodName>
                <a target="_blank" :href="suggestTermsMetaData.methodUrl">{{suggestTermsMetaData.methodName}}</a>
              </template>
            </i18n>
          </div>
        <div class="text-xs-left">
          <v-checkbox
            v-if="nonDividerTermsCount > 1"
            v-model="allTermsSelected"
            slot="activator"
            :label="numberTermsSelectedText"
            value="Select All"
            @change="handleSelectAllClick"
            hide-details
          ></v-checkbox>
        </div>
        <v-divider class="mb-2 mt-2"></v-divider>
        <template v-for="(item, index) in suggestions">
          <v-divider v-if="item.isDivider" :key="index" class="mb-2 mt-2"></v-divider>
            <v-checkbox
              v-else
              :key="index"
              :max-width="150"
              slot="activator"
              :label="item"
              v-model="chosenItems"
              :value="item"
              hide-details
            ></v-checkbox>
        </template>
        <div class="mt-3 text-xs-left modal-text" v-if="nonDividerTermsCount <= 0">
          {{ $t('modal.generatedKeywords.errorNoTermsFound') }}
        </div>
      </div>
    </base-modal>
</template>

<script>
export default {
  name: 'generated-keywords-modal',
  components: {BaseModal: () => import('./BaseModal')},
  props: ['customShowDialog', 'seedTerm', 'termKey', 'groupKey', 'value', 'suggestions', 'searchEngine'],
  data () {
    return {
      allTermsSelected: false,
      chosenItems: []
    }
  },
  computed: {
    numberTermsSelectedText: function () {
      return this.$t('modal.generatedKeywords.selectAllLabel', { selected: this.chosenItems.length, total: this.suggestions.length })
      // return 'Select All (' + this.chosenItems.length + '/' + this.suggestions.length + ' selected)'
    },
    nonDividerTermsCount: function () {
      return this.suggestions.filter(s => {
        return !s.isDivider
      }).length
    },
    suggestTermsMetaData: function () {
      return this.searchEngine.getSuggestTermsMetaData()
    }
  },
  methods: {
    handleCloseClick () {
      this.$emit('close')
      this.chosenItems = []
    },
    handleConfirmedClick () {
      this.$emit('confirmed', this.chosenItems, this.termKey, this.groupKey)
      this.chosenItems = []
    },
    handleSelectAllClick () {
      if (this.chosenItems.length === this.nonDividerTermsCount) {
        this.chosenItems = []
      } else {
        this.chosenItems = this.suggestions.filter(s => {
          return !s.isDivider
        }).map(t => {
          return t.term
        })
      }
    }
  }
}
</script>

<style scoped>
#suggest-terms-meta-text {
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/GeneratedKeywordsModal.vue